import React, { useEffect, useRef, useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import permissionsService from "services/permissionsService";
import powerBiService from "services/PowerBiService";

const SidebarContent = (props) => {
	const ref = useRef();
	const activateParentDropdown = useCallback((item) => {
		item.classList.add("active");
		const parent = item.parentElement;
		const parent2El = parent.childNodes[1];

		if (parent2El && parent2El.id !== "side-menu") {
			parent2El.classList.add("mm-show");
		}

		if (parent) {
			parent.classList.add("mm-active");
			const parent2 = parent.parentElement;

			if (parent2) {
				parent2.classList.add("mm-show"); // ul tag

				const parent3 = parent2.parentElement; // li tag

				if (parent3) {
					parent3.classList.add("mm-active"); // li
					parent3.childNodes[0].classList.add("mm-active"); //a
					const parent4 = parent3.parentElement; // ul
					if (parent4) {
						parent4.classList.add("mm-show"); // ul
						const parent5 = parent4.parentElement;
						if (parent5) {
							parent5.classList.add("mm-show"); // li
							parent5.childNodes[0].classList.add("mm-active"); // a tag
						}
					}
				}
			}
			scrollElement(item);
			return false;
		}
		scrollElement(item);
		return false;
	}, []);

	const removeActivation = (items) => {
		for (var i = 0; i < items.length; ++i) {
			var item = items[i];
			const parent = items[i].parentElement;

			if (item && item.classList.contains("active")) {
				item.classList.remove("active");
			}
			if (parent) {
				const parent2El =
					parent.childNodes &&
						parent.childNodes.lenght &&
						parent.childNodes[1]
						? parent.childNodes[1]
						: null;
				if (parent2El && parent2El.id !== "side-menu") {
					parent2El.classList.remove("mm-show");
				}

				parent.classList.remove("mm-active");
				const parent2 = parent.parentElement;

				if (parent2) {
					parent2.classList.remove("mm-show");

					const parent3 = parent2.parentElement;
					if (parent3) {
						parent3.classList.remove("mm-active"); // li
						parent3.childNodes[0].classList.remove("mm-active");

						const parent4 = parent3.parentElement; // ul
						if (parent4) {
							parent4.classList.remove("mm-show"); // ul
							const parent5 = parent4.parentElement;
							if (parent5) {
								parent5.classList.remove("mm-show"); // li
								parent5.childNodes[0].classList.remove(
									"mm-active",
								); // a tag
							}
						}
					}
				}
			}
		}
	};

	const path = useLocation();
	const activeMenu = useCallback(() => {
		const pathName = path.pathname;
		let matchingMenuItem = null;
		const ul = document.getElementById("side-menu");
		const items = ul.getElementsByTagName("a");
		removeActivation(items);

		for (let i = 0; i < items.length; ++i) {
			if (pathName === items[i].pathname) {
				matchingMenuItem = items[i];
				break;
			}
		}
		if (matchingMenuItem) {
			activateParentDropdown(matchingMenuItem);
		}
	}, [path.pathname, activateParentDropdown]);

	useEffect(() => {
		ref.current.recalculate();
	}, []);

	useEffect(() => {
		const sideMenu = document.getElementById("side-menu");
		if (!sideMenu) return;

		let metisMenuInstance;
		const init = () => {
			if (!metisMenuInstance && sideMenu.children.length > 0) {
				metisMenuInstance = new MetisMenu("#side-menu");
				activeMenu();
			}
		};

		init();

		const observer = new MutationObserver(init);
		observer.observe(sideMenu, { childList: true, subtree: true });

		return () => {
			observer.disconnect();
			metisMenuInstance?.dispose?.();
		};
	}, []);


	useEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
		activeMenu();
	}, [activeMenu]);

	function scrollElement(item) {
		if (item) {
			const currentPosition = item.offsetTop;
			if (currentPosition > window.innerHeight) {
				ref.current.getScrollElement().scrollTop =
					currentPosition - 300;
			}
		}
	}

	const [
		temPermissaoEstruturaOrganizacional,
		setTemPermissaoEstruturaOrganizacional,
	] = useState(false);
	const [temPermissaIndicadores, setTemPermissaoIndicadores] =
		useState(false);
	const [temPermissaoPlanoAcao, setTemPermissaoPlanoAcao] = useState(false);
	const [temPermissaoAtas, setTemPermissaoAtas] = useState(false);
	const [temPermissaoUsuarios, setTemPermissaoUsuarios] = useState(false);
	const [temPermissaoEmpresas, setTemPermissaoEmpresas] = useState(false);
	const [temPermissaoPerfilUsuarios, setTemPermissaoPerfilUsuarios] =
		useState(false);
	const [temPermissaoPowerBi, setTemPermissaoPowerBi] = useState(false);
	const [temPermissaoBusinessView, setTemPermissaoBusinessView] =
		useState(false);
	const [temPermissaoLoginQuotes, setTemPermissaoLoginQuotes] =
		useState(false);
	const [temPermissaoViewingPermissions, setTemPermissaoViewingPermissions] =
		useState(false);
	const [temPermissaoAgenda, setTemPermissaoAgenda] = useState(false);
	const [temPermissaoFuncoes, setTemPermissaoFuncoes] = useState(false);
	const [relatoriosPowerBi, setRelatoriosPowerBi] = useState([]);

	const getPermissions = async () => {
		try {
			// Reseta todas as permissões antes de buscar as novas
			setTemPermissaoEstruturaOrganizacional(false);
			setTemPermissaoIndicadores(false);
			setTemPermissaoPlanoAcao(false);
			setTemPermissaoAtas(false);
			setTemPermissaoUsuarios(false);
			setTemPermissaoEmpresas(false);
			setTemPermissaoPerfilUsuarios(false);
			setTemPermissaoPowerBi(false);
			setTemPermissaoBusinessView(false);
			setTemPermissaoLoginQuotes(false);
			setTemPermissaoViewingPermissions(false);
			setTemPermissaoAgenda(false);
			setTemPermissaoFuncoes(false);

			const response = await permissionsService.getPermissions();
			const userPermission = await permissionsService.getUserPermission();
			for (let permission of response) {
				if (permission.role === "orgList") {
					setTemPermissaoEstruturaOrganizacional(true);
				}
				if (permission.role === "GoalList") {
					setTemPermissaoIndicadores(true);
				}
				if (permission.role === "actionPlanList") {
					setTemPermissaoPlanoAcao(true);
				}
				if (permission.role === "ataList") {
					setTemPermissaoAtas(true);
				}
				if (permission.role === "CollaboratorList") {
					setTemPermissaoUsuarios(true);
				}
				if (permission.role === "CompanyList") {
					setTemPermissaoEmpresas(true);
				}
				if (permission.role === "permissionList") {
					setTemPermissaoPerfilUsuarios(true);
				}
				if (permission.role === "PowerBIList") {
					setTemPermissaoPowerBi(true);
				}
				if (permission.role === "intelligenceBusinessView") {
					setTemPermissaoBusinessView(true);
				}
				if (permission.role === "loginQuotesList") {
					setTemPermissaoLoginQuotes(true);
				}
				if (Number(userPermission.permission_id) === 4) {
					// consultor
					setTemPermissaoViewingPermissions(true);
				}
				if (permission.role === "meetingIndex") {
					setTemPermissaoAgenda(true);
				}
				if (permission.role === "userRolesList") {
					setTemPermissaoFuncoes(true);
				}
			}
		} catch (error) {
			console.log(error);
		}
	};

	const getRelatoriosPowerBi = async () => {
		try {
			const relatorios = await powerBiService.getRelatorios();
			setRelatoriosPowerBi(relatorios || []);
		} catch (error) {
			console.log("Erro ao buscar relatórios Power BI:", error);
			setRelatoriosPowerBi([]);
		}
	};

	const getAll = async () => {
		await getPermissions();
	};

	useEffect(() => {
		getAll();
	}, []);

	useEffect(() => {
		if (temPermissaoBusinessView) {
			getRelatoriosPowerBi();
		}
	}, [temPermissaoBusinessView]);

	// Escuta mudança de empresa para recarregar permissões
	useEffect(() => {
		const handleCompanyChange = () => {
			getAll();
		};

		window.addEventListener('companyChanged', handleCompanyChange);

		return () => {
			window.removeEventListener('companyChanged', handleCompanyChange);
		};
	}, []);

	return (
		<React.Fragment>
			<SimpleBar className="h-100" ref={ref}>
				<div id="sidebar-menu">
					<ul className="metismenu list-unstyled" id="side-menu">
						<li className="menu-title">{props.t("Menu")} </li>
						
						{/* Só mostra menu se tem empresa selecionada */}
						{localStorage.getItem("company_id") && 
						 localStorage.getItem("company_id") !== "null" && (
							<>
								<li>
									<Link to="/dashboard">
										<i className="bx bx-home-circle"></i>
										<span>{props.t("Dashboard")}</span>
									</Link>
								</li>

								{temPermissaoBusinessView && (
									<li>
										<Link to="/relatorios-power-bi">
											<i className="bx bx-line-chart"></i>
											<span>
												{props.t(
													"Inteligência Empresarial",
												)}
											</span>
										</Link>
										{relatoriosPowerBi.length > 0 && (
											<ul className="sub-menu power-bi-submenu">
												{relatoriosPowerBi.map((relatorio) => (
													<li key={relatorio.id}>
														<Link to={`/dashboard-power-bi/${relatorio.id}`}>
															<i className="bx bx-file"></i>
															<span>{relatorio.name}</span>
														</Link>
													</li>
												))}
											</ul>
										)}
									</li>
								)}

								{temPermissaoEstruturaOrganizacional && (
									<li>
										<Link to="/estrutura-organizacional">
											<i className="bx bx-sitemap"></i>
											<span>
												{props.t(
													"Estrutura organizacional",
												)}
											</span>
										</Link>
									</li>
								)}

								{temPermissaIndicadores && (
									<li>
										<Link to="/indicadores">
											<i className="bx bx-bar-chart"></i>
											<span>
												{props.t("Indicadores")}
											</span>
										</Link>
									</li>
								)}

								{temPermissaoPlanoAcao && (
									<li>
										<Link to="/planos-de-acao">
											<i className="bx bx-target-lock"></i>
											<span>
												{props.t("Planos de ação")}
											</span>
										</Link>
									</li>
								)}

								{/* <li>
									<Link to="/orcamentos">
										<i className="bx bx-dollar"></i>
										<span>{props.t('Orçamentos')}</span>
									</Link>
								</li> */}

								{temPermissaoAtas && (
									<li>
										<Link to="/atas">
											<i className="bx bx-file"></i>
											<span>{props.t("Atas")}</span>
										</Link>
									</li>
								)}
								{temPermissaoAgenda && (
									<li>
										<Link to="/agenda">
											<i className="bx bx-calendar"></i>
											<span>{props.t("Agenda")}</span>
										</Link>
									</li>
								)}

								{/* <li>
                <Link to="/reunioes">
                  <i className="bx bx-calendar"></i>
                  <span>{props.t("Reuniões")}</span>
                </Link>
              </li> */}

						<li className="menu-title">{props.t("Secundário")}</li>

						<li>
							<Link to="/#" className="has-arrow ">
								<i className="bx bx-poll"></i>
								<span>{props.t("Cadastros secundários")}</span>
							</Link>
							<ul className="sub-menu">
								{temPermissaoUsuarios && (
									<li>
										<Link to="/lista-usuarios">
											<i className="bx bx-user"></i>
											{props.t("Usuários")}
										</Link>
									</li>
								)}
								{temPermissaoFuncoes && (
									<li>
										<Link to="/user-roles">
											<i className="bx bx-id-card"></i>
											{props.t("Funções")}
										</Link>
									</li>
								)}
								{/* <li>
									<Link to="/#">
										<i className="bx bx-money"></i>
										{props.t('Folha de pagamento')}
									</Link>
								</li> */}
								{/* <li>
									<Link to="/#">
										<i className="bx bx-purchase-tag-alt"></i>
										{props.t('Produtos')}
									</Link>
								</li> */}
								{/* <li>
									<Link to="/#">
										<i className="bx bx-paste"></i>
										{props.t('Insumos')}
									</Link>
								</li> */}
								{/* <li>
									<Link to="/#">
										<i className="bx bx-transfer"></i>
										{props.t('Imoportar e exportar')}
									</Link>
								</li> */}
								{/* <li>
									<Link to="/#">
										<i className="bx bx-book-bookmark"></i>
										{props.t('Manuais')}
									</Link>
								</li> */}
							</ul>
						</li>

						<li>
							<Link to="/#" className="has-arrow ">
								<i className="bx bx-cog"></i>
								<span>{props.t("Configurações")}</span>
							</Link>
							<ul className="sub-menu config-submenu">
								{temPermissaoEmpresas && (
									<li>
										<Link to="/empresas">
											<i className="bx bx-buildings"></i>
											{props.t("Empresas")}
										</Link>
									</li>
								)}
								<li>
									<Link to="/lista-setores">
										<i className="bx bx-layer"></i>
										{props.t("Setores")}
									</Link>
								</li>
								{temPermissaoPerfilUsuarios && (
									<li>
										<Link to="/perfil-usuarios">
											<i className="bx bx-group"></i>
											{props.t("Perfil de Usuários")}
										</Link>
									</li>
								)}
								{temPermissaoPowerBi && (
									<li>
										<Link to="/relatorios-power-bi-config">
											<i className="bx bx-bar-chart-alt-2"></i>
											{props.t("Relatórios Power BI")}
										</Link>
									</li>
								)}
								{temPermissaoLoginQuotes && (
									<li>
										<Link to="/login-quotes">
											<i className="bx bx-images"></i>
											{props.t("Frases do Login")}
										</Link>
									</li>
								)}
								{temPermissaoViewingPermissions && (
									<li>
										<Link to="/viewing-permissions">
											<i className="bx bx-show"></i>
											{props.t(
												"Permissões de visualização",
											)}
										</Link>
									</li>
								)}
								{/* <li>
									<Link to="/#">
										<i className="bx bx-receipt"></i>
										{props.t('Funções')}
									</Link>
								</li>
								<li>
									<Link to="/#">
										<i className="bx bx-dollar-circle"></i>
										{props.t('Impostos')}
									</Link>
								</li>
								<li>
									<Link to="/#">
										<i className="bx bx-duplicate"></i>
										{props.t('Grupos de contas')}
									</Link>
								</li>
								<li>
									<Link to="/#">
										<i className="bx bx-captions"></i>
										{props.t('Centro de custo')}
									</Link>
								</li>
								<li>
									<Link to="/#">
										<i className="bx bx-stats"></i>
										{props.t('Encargos')}
									</Link>
								</li>
								<li>
									<Link to="/#">
										<i className="bx bx-menu-alt-left"></i>
										{props.t('Outros custos')}
									</Link>
								</li>
								<li>
									<Link to="/#">
										<i className="bx bx-list-plus"></i>
										{props.t('Adicionais')}
									</Link>
								</li>
								<li>
									<Link to="/#">
										<i className="bx bx-file"></i>
										{props.t('Relatórios B.I.')}
									</Link>
								</li>
								<li>
									<Link to="/#">
										<i className="bx bx-book"></i>
										{props.t('Manuais')}
									</Link>
								</li> */}
							</ul>
						</li>
							</>
						)}
					</ul>
				</div>
			</SimpleBar>
		</React.Fragment>
	);
};

SidebarContent.propTypes = {
	location: PropTypes.object,
	t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
